"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ScopedCssBaselineOverrides = {
    MuiScopedCssBaseline: {
        defaultProps: {
            enableColorScheme: true,
        },
        styleOverrides: {
            root: ({ theme }) => ({
                body: {
                    position: 'absolute',
                    margin: '0px',
                    overflow: 'hidden',
                    top: '0px',
                    bottom: '0px',
                    width: '100%',
                    backgroundColor: theme.palette.gray[100],
                },
            }),
        },
    },
};
exports.default = ScopedCssBaselineOverrides;
//# sourceMappingURL=ScopedCssBaselineOverrides.js.map